import config from 'config';
import {
  OwnerType,
  useGetOwnerQuery,
  useGetUserDonorsListQuery,
} from 'gql/types';

export const useOwnerData = (ownerId?: string) => {
  const ownerQuery = useGetOwnerQuery({
    variables: { input: { id: ownerId ?? '' } },
    skip: !ownerId,
  });

  const donorsQuery = useGetUserDonorsListQuery({
    variables: {
      input: {
        take: config.PAGINATION.DEFAULT_LIMIT,
        userId: ownerId ?? '',
      },
    },
    skip: !ownerId,
  });

  const owner = ownerQuery.data?.getOwner;
  const donorList = donorsQuery.data?.getUserDonorsList?.data || [];

  const isIndividualOwner = owner?.type === OwnerType.Individual;
  const hasMultipleDonors = donorList.length > 1;

  return {
    owner,
    donorList,
    isIndividualOwner,
    hasMultipleDonors,
    loading: ownerQuery.loading || donorsQuery.loading,
    error: ownerQuery.error || donorsQuery.error,
  };
};
